export const bossData = [
  {
      "name": "M1S",
      "description": "AAC Light-heavyweight - Black Cat",
      "image": "Black_Cat_P.png",
      "link": "/m1s",
      "bubbles": [
                "Earring",
                "Necklace",
                "Bracelet",
                "Ring"
            ]
  },
  {
      "name": "M2S",
      "description": "AAC Light-heavyweight - Honey B. Lovely",
      "image": "Honey_P_Lovely.png",
      "link": "/m2s",
      "bubbles": [
                "Head",
                "Glove",
                "Shoe",
                "Tomestone",
                "Shine"
            ]
  },
  {
      "name": "M3S",
      "description": "AAC Light-heavyweight - Brute Bomber",
      "image": "Brute_Bomber_P.png",
      "link": "/m3s",
      "bubbles": [
                "Chest",
                "Pant",
                "Solvent",
                "Twine"
            ]
  },
  {
      "name": "M4S",
      "description": "AAC Light-heavyweight - Wicked Thunder",
      "image": "Wicked_Thunder_P.png",
      "link": "/m4s",
      "bubbles": [
                "2x Weapons",
                "Mount",

            ]
  },
]